<input
	class="plc-range-input__slider"
	type="range"
	min="0"
	[max]="max"
	[value]="valueIndex"
	[style.background-size]="backgroudSize"
	(input)="handleInput($event.target.value)"
/>
